module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thor"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("BRAD\n                            THOR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', [_vm._v("Brad\n                        Thor spends a lot of time in Greece and has always wanted to set a novel\n                        there. When he was approached to write for this anthology, he knew right\n                        away that he wanted to write about an idea that came to him in the Greek\n                        Islands several years ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "1.5em",
      "margin-left": "5%"
    }
  }, [_c('span', [_vm._v("For decades\n                        a terrorist organization known as 17 November wreaked havoc throughout\n                        Greece. In fact, the United States still spends more money defending its\n                        embassy in Athens than any other embassy in Europe. It started in 1975 when\n                        the organization assassinated the CIA’s Athens station chief with what would\n                        become its trademark .45-caliber pistol. Since then, the group has claimed\n                        responsibility for twenty-one murders, four of which were U.S. diplomats.\n                        Though 17 November’s initial attacks were directed at senior U.S. officials\n                        and Greek public figures, they eventually expanded their targets to include\n                        ordinary citizens, foreign businesses and European Union\n                    facilities.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "1.5em",
      "margin-left": "5%"
    }
  }, [_c('span', [_vm._v("Thor was\n                        always perplexed by the government’s inability to make any progress in\n                        bringing 17 November to justice. For years, no member of the organization\n                        had ever been arrested, and no clues as to who was orchestrating their\n                        attacks had ever been found.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "1.5em",
      "margin-left": "5%"
    }
  }, [_c('span', [_vm._v("A\n                        breakthrough occurred in 2002 when a bomb being carried by a forty-year-old\n                        icon painter prematurely detonated in the Athenian port of Piraeus. The\n                        bomber was also carrying a set of keys and a prepaid telephone card, which\n                        led police to an apartment in downtown Athens packed with antitank rockets,\n                        missiles and other weapons. Within two weeks, police uncovered a string of\n                        17 November safe houses, two of which contained additional caches of\n                        weapons, disguises and the group’s signature .45-caliber Colt 1911\n                        semiautomatic pistol used in some of their most high-profile\n                        assassinations.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "1.5em",
      "margin-left": "5%"
    }
  }, [_c('span', [_vm._v("Since those\n                        successes things have been relatively quiet in Greece, but intelligence\n                        officials are concerned that several members of the organization may have\n                        slipped through their net and have gone deeper underground. These same\n                        officials worry that if and when these last remaining members do surface\n                        again, it will be with a terrible vengeance.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "1.5em",
      "margin-left": "5%"
    }
  }, [_c('span', [_vm._v("Which brings\n                        us to "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Athens\n                    Solution.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15abea17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Thor.vue
// module id = 66
// module chunks = 0